<template>
   <div>

    <div class="mysection">
      <div class="myqrcode" id="myCutImage" v-if="show">
        <div class="head_qrcode">
            <!--<div class="img_head"><img :src="webUser.headimgurl" /></div>-->
            <div class="img_head"><img :src="'data:image/jpg;base64,'+webUser.headimgurl"/></div>
            <h4>{{this.b64DecodeUnicode(webUser.nickname)}}</h4>
            <p>{{webUser.phoneNumber}}</p>
        </div>
        <div class="ad_qrcode">
            <img src="../../assets/images/wx_logo_s.png" />
            <img src="../../assets/images/wx_qrcode_banner.png" />
            <!--<img :src="downloadFileURL+webUser.quickMark+'/'" class="qrcode_regist" />-->
            <img :src="'data:image/png;base64,'+webUser.quickMark" class="qrcode_regist" />
            <p>长按二维码，惊喜等待你！</p>
          <!--<el-button  type="primary" v-on:click="myCutImageById">生成本页图片</el-button>-->
        </div>

      </div>
      <div class="mycutimage" id="addcutimage"></div>
    </div>

   </div>
</template>
<script>
  import {downloadFileURL} from '../../api/weixin-api';
  import  {reqWebUserOneById} from "../../api/weixin-api"
  import html2canvas from 'html2canvas';
  import wx from 'weixin-js-sdk';
  import {reqwxConfig} from '../../api/weixin-api';

  export default {

    data(){
          return {
            webUser:{},
            downloadFileURL:downloadFileURL,
            show:true,
            id:'',
          };
        },
        methods:{

          isWechatBrowser: function () {
            let that=this;
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf('micromessenger') !== -1;
            if (!isWeixin) {
              that.$router.push({name: 'wxError'});
            }
          },
          getWebUser(id){

            reqWebUserOneById({id:id}).then((res)=>{
              if(res.data.code===1){
                this.webUser=res.data.data;
              }
            })
          },
          myCutImageById(){
            var that=this;
            html2canvas(document.getElementById('myCutImage'),).then(function(canvas) {
              useCORS: true,
              canvas.id = "myCutImage";
              //document.body.appendChild(canvas);
              //生成base64图片数据
              var dataUrl = canvas.toDataURL();
              var newImg = document.createElement("img");
              newImg.src = dataUrl;
              //document.body.appendChild(newImg);
              document.getElementById('addcutimage').appendChild(newImg);
//              $(newImg).css({
//                "width": canvas.width / 2 + "px",
//                "height": canvas.height / 2 + "px",
//              })
              that.show = false;
//              var triggerDownload = $("<a>").attr("href", dataUrl).attr("download", "idCard.png").appendTo("body");
//              triggerDownload[0].click();
//              triggerDownload.remove();
//            var printWindow = window.open(newImg.src);
//            printWindow.document.write('<img src="' + newImg.src + '" />')
//            printWindow.print();
//          document.getElementById('myCutImage').appendChild(newImg);
//          document.getElementById('myCutImage').appendChild(canvas);

            });
          },
          backWeiXin:function() {
            pushHistory();
            function bodyScroll(){
              window.location.href='/wxMyHomePage';
            }
            window.addEventListener("popstate",bodyScroll, false);
            function pushHistory() {
              var state = {
                title: "title",
                url: "#"
              };
              window.history.pushState(state, state.title, state.url);
            }
          },
          initwx(){
            var url=window.location.href;
            reqwxConfig({qrurl:url}).then((res)=>{
              console.info(res)
//              debugger
              //微信注入权限接口
              wx.config({
                debug: false,
                appId: res.data.data.appId,
                timestamp: res.data.data.timestamp,
                nonceStr: res.data.data.noncestr,
                signature: res.data.data.signature,
                jsApiList: [
//                  'onMenuShareAppMessage',
//                  'hideMenuItems',
                  'hideOptionMenu',
//                  'hideToolbar',
                ]
              });
// 隐藏右上角三个点按钮：
              wx.hideOptionMenu();
              WeixinJSBridge.call('hideToolbar')

//              document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
//                WeixinJSBridge.call('hideOptionMenu');//隐藏右上角菜单
//
//              });

//  隐藏按钮在iphone下失效
//              wx.hideMenuItems({
//                menuList: [ "menuItem:share:appMessage","menuItem:share:timeline"],// 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
//                success:function(res){
//                  console.info("Yincang成功")
//                }
//              });
//              分享给朋友
//              wx.onMenuShareAppMessage({
//                title: 'welcome', // 分享标题
//                desc: 'welcome', // 分享描述
//                link: 'www.phjd365.com/wxmyQRCode?id='+this.id, // 分享链接
//                imgUrl: '', // 分享图标
//                type: 'link', // 分享类型,music、video或link，不填默认为link
//                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
//                success: function () {
//// 用户确认分享后执行的回调函数
//                  console.info("确认发送给朋友成功")
//                },
//                cancel: function () {
//// 用户取消分享后执行的回调函数
//                  console.info("取消发送给朋友")
//                }
//              });
            })
          },

 // 微信头像解码
          b64DecodeUnicode(str) {
            return decodeURIComponent(atob(str).split('').map(function(c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
          }

        },
        mounted(){
            this.$store.dispatch('hideHF');
            this.isWechatBrowser();
            var id=this.$route.query.id;
            this.id=id;
          if(id){
            this.getWebUser(id);
            setTimeout(_ => {
              this.myCutImageById();
            },2000);
            setTimeout(_ => {
              this.initwx();
            },1000)
          }
          this.backWeiXin();
        },
    }
</script>
<style slot-scope="scope">
    @import '../../assets/css/wxstyle.css';
</style>



// WEBPACK FOOTER //
// src/components/weChat/WxmyQRCode.vue